// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"5fbd3c41","349":"72846928","380":"1e6c7133","453":"f6ed8d92","701":"2855c402","825":"bd1e860a"}[chunkId] + ".chunk.js";
};